import { render, staticRenderFns } from "./SubmissionFormAttachments.vue?vue&type=template&id=44bca603&scoped=true&"
import script from "./SubmissionFormAttachments.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bca603",
  null
  
)

export default component.exports